<template>
  <v-dialog v-model="dialog" max-width="600" persistent v-resize="onResize">
    <v-card class="user-card">
      <!-- Header -->
      <div class="user-card-header">
        <h2 class="user-card-title">ดาวน์โหลดรูปภาพผู้ปฏิบัติการ</h2>
        <v-btn icon class="user-card-close-btn" @click="closeCard" variant="text">
          <v-icon color="#555">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-divider class="user-card-divider"></v-divider>
      <v-row dense align="center" class="user-card-row">
        <v-col cols="12" md="3" class="user-card-label">
          เลขที่บัตรประชาชน
        </v-col>
        <v-col cols="12" md="7">
          <v-text-field v-model="id_card_num" outlined clearable dense placeholder="กรอกเลขบัตร 13 หลัก"
            ref="idCardInput" prepend-inner-icon="mdi-card-account-details-outline" color="primary"
            background-color="white" hide-details="auto" class="user-card-input"
            :onkeypress="`return ((event.charCode >= 48 && event.charCode <= 57) && &quot;${id_card_num}&quot;.length<13)`"
            :rules="[
              ...rules.number,
              ...rules.textLength13,
            ]" lazy-rules></v-text-field>
        </v-col>
        <v-col v-if="windowSize.x >= 960" cols="12" md="2" class="user-card-label">
          <v-btn color="#91CBA2" class="ml-2 white--text user-card-submit-btn" @click="submitCard">
            ยืนยัน
          </v-btn>
        </v-col>
        <v-col v-else cols="12" md="12" class="user-card-label-small">
          <v-btn color="#91CBA2" class="white--text user-card-submit-btn" @click="submitCard">
            ยืนยัน
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

  </v-dialog>
</template>
<script>
import { EventBus } from '../EventBus';
export default {
  data: () => ({
    windowSize: { x: 0, y: 0 },
    loading: false,
    dialog: false,
    id_card_num: '',
    rules: {
      required: [(v) => !!v],
      number: [
        (v) => (!isNaN(v) && /^[0-9]*$/.test(v)),
      ],
      textLength13: [(v) => (v.length == 13)],
    },
  }),
  mounted() {
    this.onResize();
    EventBus.$on("gotoDownloadImage", this.openDialog)
  },
  beforeDestroy() {
    EventBus.$off("gotoDownloadImage")
  },
  computed: {

  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth };
    },
    openDialog() {
      this.dialog = true;
      this.$nextTick(() => {
        if (this.$refs.idCardInput) {
          this.$refs.idCardInput.resetValidation();
        }
      });
    },
    closeCard() {
      this.dialog = false;
      this.id_card_num = '';
      this.$nextTick(() => {
        if (this.$refs.idCardInput) {
          this.$refs.idCardInput.resetValidation();
        }
      });
    },

    async submitCard() {
      try {
        this.loading = true

        if (this.id_card_num.length !== 13) {
          EventBus.$emit('alert-error', 'กรุณากรอกเลขบัตรประชาชนให้ครบ 13 หลัก')
          return
        }

        const setData = {
          baseURL: process.env.VUE_APP_API_URL,
          url: `/public/api/v1/showimage_public/${this.id_card_num}`,
          method: "GET",
          responseType: "blob",
        }
        const { data } = await this.axios(setData)
        if (data) {
          const type = data.type.split('/')[1]
          const url = window.URL.createObjectURL(new Blob([data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.id_card_num}.${type}`)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)

          EventBus.$emit('alert-success', 'ดาวน์โหลดรูปภาพเสร็จเรียบร้อย')
          this.dialog = false
        }
      } catch (error) {
        console.log(error);
        if (error.response) {
          try {
            const message = JSON.parse(await error.response.data.text());
            if (message?.message === 'image not found') {
              EventBus.$emit('alert-error', 'ไม่พบรูปภาพ กรุณาลองใหม่อีกครั้ง');
              return;
            }
          } catch (e) {
            console.log("Response is not in JSON format: ", e);
          }
          if (error.response.status === 404) {
            EventBus.$emit('alert-error', 'ไม่พบรูปภาพ กรุณาตรวจสอบข้อมูล');
          }
        } else {
          EventBus.$emit('alert-error', 'ไม่สามารถ ดาวน์โหลดรูปภาพ ได้ กรุณาติดต่อเจ้าหน้าที่');
        }
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style scoped>
.user-card {
  width: 100%;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  font-family: 'Noto Sans Thai', sans-serif;
  padding: 24px 32px;
  color: #2c3e50;
}

.user-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.user-card-title {
  font-weight: 700;
  font-size: 1.3rem;
  color: #34495e;
  margin: 0;
}

.user-card-close-btn {
  transition: background-color 0.3s ease;
}

.user-card-close-btn:hover {
  background-color: rgba(52, 73, 94, 0.1);
}

.user-card-divider {
  margin-bottom: 24px;
  border-color: #ecf0f1;
}

.user-card-row {
  margin-bottom: 24px;
}

.user-card-label {
  font-weight: 600;
  font-size: 1rem;
  color: #34495e;
  display: flex;
  align-items: center;
}

.user-card-label-small {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-bottom: -24px;
  padding-top: 15px;
}


.user-card-input .v-input__control {
  background-color: #fefefe !important;
  border-radius: 8px;
}

.user-card__actions {
  margin-top: 12px;
}

.user-card-submit-btn {
  font-weight: 600;
  text-transform: none;
  border-radius: 8px;
  padding-left: 24px;
  padding-right: 24px;
  box-shadow: 0 4px 10px rgba(41, 128, 185, 0.25);
  transition: box-shadow 0.3s ease;
}

.user-card-input ::v-deep(.v-input__prepend-inner) {
  margin-right: 15px !important;
  display: flex;
  align-items: center;
}

.user-card-input ::v-deep(.v-input__prepend-inner .v-icon) {
  font-size: 26px !important;
  color: #224870 !important;
}

.user-card-submit-btn:hover {
  box-shadow: 0 6px 14px rgba(41, 128, 185, 0.45);
}
</style>
